var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"250px","background-color":"#ebf0ff"}},[_c('v-layout',{attrs:{"wrap":"","pt-4":"","pb-16":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-family":"robotoMedium","color":"#000","font-size":"20px"}},[_vm._v("Terms and Conditions")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }